var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.23333V22C24 22.5333 23.8 23 23.4 23.4C23 23.8 22.5333 24 22 24H2C1.46667 24 1 23.8 0.6 23.4C0.2 23 0 22.5333 0 22V2C0 1.46667 0.2 1 0.6 0.6C1 0.2 1.46667 0 2 0H18.7667L24 5.23333ZM12 19.8333C12.9556 19.8333 13.7722 19.4944 14.45 18.8167C15.1278 18.1389 15.4667 17.3222 15.4667 16.3667C15.4667 15.4111 15.1278 14.5944 14.45 13.9167C13.7722 13.2389 12.9556 12.9 12 12.9C11.0444 12.9 10.2278 13.2389 9.55 13.9167C8.87222 14.5944 8.53333 15.4111 8.53333 16.3667C8.53333 17.3222 8.87222 18.1389 9.55 18.8167C10.2278 19.4944 11.0444 19.8333 12 19.8333ZM3.76667 8.53333H15.7V3.76667H3.76667V8.53333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1705cc3e6ebe4f8a479f7091621c080b.svg";
export { ForwardRef as ReactComponent };